import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { posDeliveryMethods } from "@/shared/utils/constant";
import { CategoryCardPositionEnum } from "@/shared/utils/enum";
import { PosUserSettings } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

export type ColumnCountPerCategoryArrayItem = {
  categoryId: number[];
  columnCount: number;
};
interface ColumnCountPerCategoryArray {
  column_count_per_category_array?: ColumnCountPerCategoryArrayItem[];
}

const usePosUserSettingsQuery = () => {
  const branchId = useBranchId();
  const query = useQuery<PosUserSettings & ColumnCountPerCategoryArray>({
    queryKey: ["pos-user-settings", branchId],
    queryFn: () => get2(`internal/secure/pos/v1/user/pos/setting/${branchId}`),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    select: (data) => {
      const ret = {
        ...data,
        category_card_position: data.category_card_position
          ? data.category_card_position
          : data.category_card_left
            ? 2
            : 1
      };

      if (data.column_count_per_category) {
        const newColumnCountPerCategory = {};
        Object.entries(data.column_count_per_category).forEach(
          ([key, value]: [string, number]) => {
            if (newColumnCountPerCategory[value]) {
              newColumnCountPerCategory[value].push(Number(key));
            } else {
              newColumnCountPerCategory[value] = [Number(key)];
            }
          }
        );

        ret.column_count_per_category_array = Object.entries(
          newColumnCountPerCategory
        ).map(([key, value]) => ({
          categoryId: value as number[],
          columnCount: Number(key)
        }));
      }

      ret.is_map_view = data.is_map_view ?? true;
      ret.is_cart_on_right = data.is_cart_on_right ?? true;
      ret.font_size = data.font_size ?? 15;
      ret.category_card_position =
        data.category_card_position ?? CategoryCardPositionEnum.LEFT;
      ret.category_column_count = data.category_column_count ?? 8;
      ret.product_column_count = data.product_column_count ?? 8;
      ret.delivery_method_options =
        data.delivery_method_options ??
        posDeliveryMethods.map(({ value }) => value);
      ret.is_always_ask_for_topping = data.is_always_ask_for_topping ?? false;
      ret.show_print_popup = data.show_print_popup ?? true;
      return ret;
    }
  });

  return query;
};

export default usePosUserSettingsQuery;
